module.exports = __webpack_public_path__ + "static/media/wave.53aab098.png";